export default "__VITE_ASSET__DF3PIw_A__"